export default "__VITE_ASSET__de4f607d__"